// import React, {useState, useEffect} from 'react';
// import {List, ListItem, ListItemText, Divider} from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Presupuestos = props => {
//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   const [gestionPresupuestos, setGestionPresupuestos] = useState(false);
//   const [misPresupuestos, setMisPresupuestos] = useState(false);
//   const [presupuestosGeneral, setPresupuestosGeneral] = useState(false);

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const VerificarPermisos = arrPermisos => {
//     setMisPresupuestos(EvaluarPermiso(arrPermisos, '/misPresupuestos'));
//     setPresupuestosGeneral(
//       EvaluarPermiso(arrPermisos, '/presupuestosGeneral')
//     );
//     setGestionPresupuestos(
//         EvaluarPermiso(arrPermisos, '/gestionPresupuestos')
//       );
//   };

//   const [openGestionPresupuestos, setOpenGestionPresupuestos] = useState(false);
//   const handleOpenGestionPresupuestos = () => {
//     setOpenGestionPresupuestos(!openGestionPresupuestos);
//   };

//   return (<React.Fragment>
// {gestionPresupuestos ? (
//         <List>
//           <ListItem onClick={handleOpenGestionPresupuestos}>
//             <i notranslate="true" className="material-icons">
//               monetization_on
//             </i>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Gestión de Presupuestos"
//             />
//             {openGestionPresupuestos ? <ExpandLess /> : <ExpandMore />}
//           </ListItem>
//           <Collapse in={openGestionPresupuestos} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               {misPresupuestos ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/misPresupuestos"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     assignment_turned_in
//                   </i>
//                   <ListItemText primary="Mis Presupuestos" />
//                 </ListItem>
//               ) : null}
//               {presupuestosGeneral ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/presupuestosGeneral"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     article
//                   </i>
//                   <ListItemText primary="Presupuestos General" />
//                 </ListItem>
//               ) : null}
//             </List>
//           </Collapse>
//         </List>
//       ) : null}
//       {gestionPresupuestos ? <Divider /> : null}
//   </React.Fragment>)
// }

//   export default Presupuestos
import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Collapse } from '@mui/material';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ArticleIcon from '@mui/icons-material/Article';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Presupuestos = ({ sesionUsuario }) => {
  const [gestionPresupuestos, setGestionPresupuestos] = useState(false);
  const [misPresupuestos, setMisPresupuestos] = useState(false);
  const [presupuestosGeneral, setPresupuestosGeneral] = useState(false);
  const [openGestionPresupuestos, setOpenGestionPresupuestos] = useState(false);

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setMisPresupuestos(EvaluarPermiso(permisos, '/misPresupuestos'));
    setPresupuestosGeneral(EvaluarPermiso(permisos, '/presupuestosGeneral'));
    setGestionPresupuestos(EvaluarPermiso(permisos, '/gestionPresupuestos'));
  }, [sesionUsuario]);

  const handleOpenGestionPresupuestos = () => {
    setOpenGestionPresupuestos(!openGestionPresupuestos);
  };

  return (
    <>
      {gestionPresupuestos && (
        <>
          <ListItem
            button
            onClick={handleOpenGestionPresupuestos}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <RequestQuoteIcon />
            </ListItemIcon>
            <ListItemText
              primary="Gestión de Presupuestos"
              sx={menuItemStyles.menuText}
            />
            {openGestionPresupuestos ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openGestionPresupuestos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {misPresupuestos && (
                <ListItem
                  button
                  component={Link}
                  to="/misPresupuestos"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AssignmentTurnedInIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mis Presupuestos"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {presupuestosGeneral && (
                <ListItem
                  button
                  component={Link}
                  to="/presupuestosGeneral"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ArticleIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Presupuestos General"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Presupuestos;
